<template>
  <div class="bg-[#222637] bg-fixed bg-norepeat bg-bottom text-white flex flex-col h-screen">
    <div
      class="h-[60px] flex items-center pl-12 bg-[url(@/assets/images/logo.png)] bg-position-[20px] bg-no-repeat bg-size-[25px_20px] text-base font-medium"
    >
      <div
        :class="isCollapse ? 'w-0 text-sm' : 'w-50 text-base'"
        class="transition-all delay-180 overflow-hidden text-nowrap"
      >
        昕晟环保销售管理系统
      </div>
    </div>
    <div class="h-[calc(100vh-60px)] overflow-auto box-content relative">
      <div
        class="absolute inset-0 bg-[url(@/assets/images/menu_bottom.png)] bg-bottom bg-no-repeat bg-size-[100%] z-0 w-full h-full"
      ></div>

      <!-- 透明颜色层（z-index更高） -->
      <div class="absolute inset-0 bg-blue-500/30 z-10"></div>

      <!-- 内容层 -->
      <el-menu
        :default-active="defaultActive"
        :router="true"
        background-color="#222637"
        text-color="#bfcbd9"
        active-text-color="#409eff"
        class="w-full h-full text-white! border-none! relative z-20"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
        @select="menuChange"
      >
        <el-menu-item class="first-el-menu-item" index="/index">
          <el-icon>
            <House />
          </el-icon>
          <span>首页</span>
        </el-menu-item>

        <el-sub-menu v-for="item in menuArray" :key="item.id" :index="item.path">
          <template #title>
            <el-icon>
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item v-for="m in item.children" :key="m.id" :index="m.path">
            {{ m.name }}
            <!-- <div>{{m.path}}</div> -->
          </el-menu-item>
        </el-sub-menu>

        <!--
        <el-sub-menu index="">
          <template #title>
            <el-icon>
              <Folder />
            </el-icon>
            <span>项目管理</span>
          </template>
          <el-menu-item index="/project">项目信息</el-menu-item>
          <el-menu-item index="/projectStatistics">数据统计</el-menu-item>
          <el-menu-item-group title="Group Two">
            <el-menu-item index="1-3">item three</el-menu-item>
          </el-menu-item-group>
          <el-sub-menu index="1-4">
            <template #title><span>item four</span></template>
            <el-menu-item index="1-4-1">item one</el-menu-item>
          </el-sub-menu>
        </el-sub-menu>

        <el-sub-menu index="">
          <template #title>
            <el-icon>
              <User />
            </el-icon>
            <span>单位客户管理</span>
          </template>
          <el-menu-item index="/project">
            <span>单位客户信息</span>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="">
          <template #title>
            <el-icon>
              <Document />
            </el-icon>
            <span>基础信息管理</span>
          </template>
          <el-menu-item index="/baseInfo">
            <span>公司管理</span>
          </el-menu-item>
          <el-menu-item index="/baseInfo">
            <span>用户管理</span>
          </el-menu-item>
          <el-menu-item index="/baseInfo">
            <span>省份管理</span>
          </el-menu-item>
          <el-menu-item index="/baseInfo">
            <span>项目状态管理</span>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="">
          <template #title>
            <el-icon>
              <Lock />
            </el-icon>
            <span>权限管理</span>
          </template>
          <el-menu-item index="/document">角色管理</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="">
          <template #title>
            <el-icon>
              <Monitor />
            </el-icon>
            <span>系统管理</span>
          </template>
          <el-menu-item index="/system/log">操作日志</el-menu-item>
        </el-sub-menu> -->
      </el-menu>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/stores'
import emitter from '@/utils/eventBus'
import { onMounted, onUnmounted, ref, onBeforeUpdate } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const storeUserInfo = useUserStore()

const isCollapse = ref(false)

const handleOpen = (a) => {
  // emit('update:activeMenu', key)
  console.log('open:', a, menuArray)
}
const menuChange = (key: string, keyPath: string[]) => {
  storeUserInfo.nowMenu = keyPath //存储当前点击的菜单
  emitter.emit('mittActiveMenu', keyPath)
}

const handleClose = () => {}

const menuArray = ref()
const defaultActive = ref('')
onMounted(() => {
  //处理刷新后默认选择的菜单
  defaultActive.value = storeUserInfo.nowMenu[storeUserInfo.nowMenu.length - 1]

  emitter.on('mittCollapse', (val) => {
    isCollapse.value = val as boolean
  })

  menuArray.value = storeUserInfo.userRole.filter(item => item.type === 'menu')

  const handleResize = () => {
    const mainEl = document.querySelector('body')
    if (mainEl && mainEl.clientWidth <= 1024) {
      isCollapse.value = true
    } else {
      isCollapse.value = false
    }
  }
  handleResize()

  window.addEventListener('resize', handleResize)

  // 清理函数，用于移除事件监听器
  return () => {
    window.removeEventListener('resize', handleResize)
  }
})

onUnmounted(() => {
  emitter.off('mittCollapse') // 清理
})

onBeforeUpdate(() => {
  const currRoute = router?.currentRoute.value?.fullPath
  let stack = [
    ...JSON.parse(
      JSON.stringify(menuArray.value.map((item) => ({ ...item, pathList: [item.path] }))),
    ),
  ]
  let pathList = []
  while (stack.length) {
    const curr = stack.pop()
    if (curr.path === currRoute) {
      pathList = curr.pathList
      break
    } else if (curr?.children?.length) {
      stack = [
        ...stack,
        ...curr.children.map((item) => ({ ...item, pathList: [...curr.pathList, item.path] })),
      ]
    }
  }
  const currPath = pathList[pathList.length - 1]
  menuChange(currPath, pathList)
  defaultActive.value = currPath
})
</script>

<style lang="less" scoped>
:deep(.el-menu-vertical-demo:not(.el-menu--collapse)) {
  width: 200px;
  min-height: 400px;
}

:deep(.el-sub-menu, .el-sub-menu__title) {
  background-color: rgba(34, 38, 55, 0.8);
}

.first-el-menu-item {
  background-color: rgba(34, 38, 55, 0.8) !important;
}

.first-el-menu-item:hover {
  background-color: var(--el-menu-hover-bg-color) !important;
}

:deep(.el-menu-item) {
  background-color: rgba(34, 38, 55, 0);
}

:deep(.el-menu) {
  background-color: rgba(34, 38, 55, 0);
}

:deep(.el-menu--inline) {
  background-color: rgba(34, 38, 55, 0);
}

// .el-sub-menu,
// .el-sub-menu__title,
// .el-menu--inline,
// .el-menu {
//   background-color: rgba(34, 38, 55, 0.5) !important;
// }
</style>
